function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_43",
  "data-name": "Trazado 43",
  d: "M19.383,39.518a1.706,1.706,0,0,0-1.146-1.609,6.568,6.568,0,0,0-2.566-5.271A9.857,9.857,0,0,0,9.691,31a9.857,9.857,0,0,0-5.979,1.638,6.568,6.568,0,0,0-2.566,5.271,1.7,1.7,0,0,0-.711,2.745A1.7,1.7,0,0,0,1.158,43.4a5.141,5.141,0,0,0,5.126,4.633H13.1A5.141,5.141,0,0,0,18.225,43.4a1.7,1.7,0,0,0,.723-2.749A1.7,1.7,0,0,0,19.383,39.518ZM9.691,32.136c3.257,0,7.115,1,7.4,5.679H2.289C2.576,33.14,6.435,32.136,9.691,32.136ZM1.7,38.95H17.679a.568.568,0,1,1,0,1.136H1.7a.568.568,0,1,1,0-1.136ZM13.1,46.9H6.284a4.007,4.007,0,0,1-3.972-3.407h.527a.845.845,0,0,1,.739.386,1.938,1.938,0,0,0,1.571.749,1.884,1.884,0,0,0,1.559-.757.86.86,0,0,1,1.425,0,1.884,1.884,0,0,0,1.559.757,1.884,1.884,0,0,0,1.559-.757.86.86,0,0,1,1.425,0,1.984,1.984,0,0,0,3.118,0,.8.8,0,0,1,.713-.379h.565A4.007,4.007,0,0,1,13.1,46.9Zm4.581-4.543H16.506a1.884,1.884,0,0,0-1.559.757.86.86,0,0,1-1.425,0,1.984,1.984,0,0,0-3.118,0,.86.86,0,0,1-1.425,0,1.884,1.884,0,0,0-1.559-.757,1.884,1.884,0,0,0-1.559.757.8.8,0,0,1-.713.379.845.845,0,0,1-.739-.386,1.938,1.938,0,0,0-1.571-.749H1.7a.568.568,0,0,1,0-1.136H17.679a.568.568,0,0,1,0,1.136Z",
  transform: "translate(0 -31)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_109",
  "data-name": "Elipse 109",
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  transform: "translate(5.176 3.781)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_110",
  "data-name": "Elipse 110",
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  transform: "translate(13.176 4.781)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_111",
  "data-name": "Elipse 111",
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  transform: "translate(10.176 2.781)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_112",
  "data-name": "Elipse 112",
  cx: 0.5,
  cy: 0.5,
  r: 0.5,
  transform: "translate(8.176 4.781)",
  fill: "#fff"
});

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "burger",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.383,
    height: 17.036,
    viewBox: "0 0 19.383 17.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.403a44cd.svg";
export { ForwardRef as ReactComponent };